export default {
  CAMPAIGN_DETAIL: "Referral Campaign Details",
  ENROLL_DETAIL: {
    MAIN: "A. Community Invites Residents To Enroll",
    SMS: "1. Via Email/SMS",
    PORTAL: "2. Via Resident Portal",
    DIRECT: "3. Via Direct Link"
  },
  RESIDENT_ENROLL: "B. Resident Enrolls",
  THANKYOU_ENROLL: "C. Resident Receives Email Upon Enrolling",
  INVITE_FRIEND: {
    MAIN: "D. Resident Invites A Friend",
    MAX: " 1. Share Options",
    DEFAULT: "2. Provide a default to resident when inviting a friend",
    LANDING_PAGE: "3. Refer-a-Friend Landing Page",
    CONFIRMATION: "4. Confirmation"
  },
  GET_IN_TOUCH: "D. Friend Gets In Touch",
  DISCOUNT_DETAIL: "E. Resident Gets Discount"
}